<template>
  <div class="bg-white p-4 rounded-lg mb-2">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
